import React, { useReducer, useState } from 'react'
import Provider from 'streamr-client-react'
import styled from 'styled-components'
import { DESKTOP } from '@streamr/streamr-layout/styled'
import NetworkStats from './NetworkStats'
import InteractionEncourager from './InteractionEncourager'
import PrestyledNav from '~shared/Nav'
import LoadingIndicator from '~shared/LoadingIndicator'
import NetworkExplorer from '~shared/NetworkVisualizer/NetworkExplorer'
import useIsMounted from '~hooks/useIsMounted'

const Wrap = styled.div`
    height: 0;
    overflow: visible;
`

const StatsWrap = styled.div`
    flex-grow: 1;
    margin-left: 24px;

    ${NetworkStats} {
        margin: 0 auto;
    }

    @media (min-width: ${DESKTOP}px) {
        ${NetworkStats} {
            margin: 0;
        }
    }
`

const Nav = styled(PrestyledNav)`
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
`

function UnstyledVisualizerNav({ className, offsetFn }) {
    const [data, setData] = useState()

    const [fetching, setFetching] = useState(false)

    const loading = !data || fetching

    const [point, setPoint] = useState()

    const [ready, setReady] = useReducer(() => true, false)

    const isMounted = useIsMounted()

    return (
        <>
            <Nav
                afterLogoComponent={(
                    <StatsWrap>
                        <Provider
                            autoConnect
                            autoDisconnect
                            restUrl="https://streamr.network/api/v1"
                            url="wss://testnet1.streamr.network:7006"
                            verifySignatures="never"
                        >
                            <NetworkStats data={data} point={point} />
                        </Provider>
                    </StatsWrap>
                )}
            />
            <div className={className}>
                {ready && (
                    <InteractionEncourager />
                )}
                <Wrap>
                    <LoadingIndicator large loading={loading} />
                </Wrap>
                <NetworkExplorer
                    offsetFn={offsetFn}
                    onIntroDone={setReady}
                    onLoaded={setData}
                    onNodeChange={setPoint}
                    setLoading={(value) => {
                        if (isMounted()) {
                            setFetching(value)
                        }
                    }}
                />
            </div>
        </>
    )
}

const VisualizerNav = styled(UnstyledVisualizerNav)`
    height: 100%;
    width: 100%;
`

export default VisualizerNav
